import { render, staticRenderFns } from "./modalHistory.vue?vue&type=template&id=7fdeced6&"
import script from "./modalHistory.vue?vue&type=script&lang=js&"
export * from "./modalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports